import React, { useEffect, useState, useMemo } from 'react'
import Container from 'react-bootstrap/Container'
import PhotoAlbum from 'react-photo-album'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../Firebase'

import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen'
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

import SpinnerComponents from '../../components/Spinner/SpinnerComponents'
import SEO from '../../components/SEO'
import './Gallery.css'

const Gallery = () => {
  const [collections, setCollections] = useState([])
  const [index, setIndex] = useState(-1)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'Gallery'))
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        setCollections(list)
      } catch (err) {
        console.error('Gallery fetch error:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchCollections()
  }, [])

  const photos = useMemo(() => {
    return collections.map((item) => ({
      src: item.src || item.image,
      width: item.width || 800,
      height: item.height || 600,
      alt: item.title || 'Salon work',
      title: item.title,
    })).filter((p) => p.src)
  }, [collections])

  const lightboxSlides = useMemo(() => {
    return photos.map((p) => ({
      src: p.src,
      alt: p.alt,
      title: p.title,
    }))
  }, [photos])

  return (
    <div className="gallery-page">
      <SEO title="Hair Gallery" description="Some of our work and perfection." />
      <Container className="gallery-container">
        <header className="gallery-header">
          <span className="gallery-label">Portfolio</span>
          <h1 className="gallery-title">Gallery</h1>
          <p className="gallery-desc">Our work — braiding, styling and perfection at its core.</p>
        </header>

        {loading ? (
          <div className="gallery-loading">
            <SpinnerComponents />
          </div>
        ) : photos.length === 0 ? (
          <div className="gallery-empty">
            <p>No photos in the gallery yet. Check back soon.</p>
          </div>
        ) : (
          <div className="gallery-album-wrap">
            <PhotoAlbum
              layout="rows"
              photos={photos}
              targetRowHeight={280}
              spacing={12}
              onClick={({ index: i }) => setIndex(i)}
            />
          </div>
        )}
      </Container>

      <Lightbox
        slides={lightboxSlides}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
    </div>
  )
}

export default Gallery
